import {ICacheService} from '@/services/iCacheService';
import {LocalCacheService} from '@/services/impl/localCacheService';
import {IHttpService} from '@/services/iHttpService';
import {AxiosHttpService} from '@/services/impl/axiosHttpService';
import {IRequestService} from '@/services/iRequestService';
import {RequestService} from '@/services/impl/requestService';
import {IMemberService} from '@/services/iMemberService';
import {IProviderService} from '@/services/iProviderService';
import {ISubscriptionService} from '@/services/iSubscriptionService';
import {IOrganizationService} from '@/services/iOrganizationService';
import {IPaymentSourceService} from '@/services/iPaymentSourceService';
import {IPatientService} from '@/services/iPatientService';
import {PatientService} from '@/services/impl/patientService';
import {PaymentSourceService} from '@/services/impl/paymentSourceService';
import {SubscriptionService} from '@/services/impl/subscriptionService';
import {OrganizationService} from '@/services/impl/organizationService';
import {ProviderService} from '@/services/impl/providerService';
import {MemberService} from '@/services/impl/memberService';
import {IUserService} from '@/services/iUserService';
import {UserService} from '@/services/impl/userService';
import {IInvoiceService} from '@/services/iInvoiceService';
import {InvoiceService} from '@/services/impl/InvoiceService';
import {IRxProviderService} from '@/services/iRxProviderService';
import {RxProviderService} from '@/services/impl/rxProviderService';
import {ITransporterService} from '@/services/iTransporterService';
import {TransporterService} from '@/services/impl/transporterService';
import {IInterpreterService} from '@/services/iInterpreterService';
import {InterpreterService} from '@/services/impl/interpreterService';
import {IFileService} from '@/services/iFileService';
import {FileService} from '@/services/impl/fileService';
import {DriverService} from '@/services/impl/driverService';
import {IDriverService} from '@/services/iDriverService';

/**
 * @author <Aniket.P>
 * @description Object Factory
 * @copyright Supra International, inc
 */
export class ObjectFactory {


    public static getCacheService(): ICacheService {
        if (!this.iCacheService) {
            this.iCacheService = new LocalCacheService();
        }
        return this.iCacheService;
    }

    public static getHttpService(): IHttpService {
        if (!this.iHttpService) {
            this.iHttpService = new AxiosHttpService();
        }
        return this.iHttpService;
    }

    public static getRequestService(): IRequestService {
        if (!this.iRequestService) {
            this.iRequestService = new RequestService();
        }
        return this.iRequestService;
    }

    public static getMemberService(): IMemberService {
        if (!this.iMemberService) {
            this.iMemberService = new MemberService();
        }
        return this.iMemberService;
    }


    public static getProviderService(): IProviderService {
        if (!this.iProviderService) {
            this.iProviderService = new ProviderService();
        }
        return this.iProviderService;
    }


    public static getSubscriptionService(): ISubscriptionService {
        if (!this.iSubscriptionService) {
            this.iSubscriptionService = new SubscriptionService();
        }
        return this.iSubscriptionService;
    }


    public static getOrganizationService(): IOrganizationService {
        if (!this.iOrganizationService) {
            this.iOrganizationService = new OrganizationService();
        }
        return this.iOrganizationService;
    }


    public static getPaymentSourceService(): IPaymentSourceService {
        if (!this.iPaymentSourceService) {
            this.iPaymentSourceService = new PaymentSourceService();
        }
        return this.iPaymentSourceService;
    }


    public static getPatientService(): IPatientService {
        if (!this.iPatientService) {
            this.iPatientService = new PatientService();
        }
        return this.iPatientService;
    }

    public static getUserService(): IUserService {
        if (!this.iUserService) {
            this.iUserService = new UserService();
        }
        return this.iUserService;
    }

    public static getInvoiceService(): IInvoiceService {
        if (!this.iInvoiceService) {
            this.iInvoiceService = new InvoiceService();
        }
        return this.iInvoiceService;
    }

    public static getRxProviderService(): IRxProviderService {
        if (!this.iRxProviderService) {
            this.iRxProviderService = new RxProviderService();
        }
        return this.iRxProviderService;
    }

    public static getTransporterService(): ITransporterService {
        if (!this.iTransporterService) {
            this.iTransporterService = new TransporterService();
        }
        return this.iTransporterService;
    }

    public static getDriverService(): IDriverService {
        if (!this.iDriverService) {
            this.iDriverService = new DriverService();
        }
        return this.iDriverService;
    }

    public static getInterpreterService(): IInterpreterService {
        if (!this.iInterpreterService) {
            this.iInterpreterService = new InterpreterService();
        }
        return this.iInterpreterService;

    }

    public static getFileService(): IFileService {
        if (!this.iFileService) {
            this.iFileService = new FileService();
        }
        return this.iFileService;
    }

    private static iCacheService: ICacheService;
    private static iHttpService: IHttpService;
    private static iRequestService: IRequestService;
    private static iMemberService: IMemberService;
    private static iProviderService: IProviderService;
    private static iSubscriptionService: ISubscriptionService;
    private static iOrganizationService: IOrganizationService;
    private static iPaymentSourceService: IPaymentSourceService;
    private static iPatientService: IPatientService;
    private static iUserService: IUserService;
    private static iInvoiceService: IInvoiceService;
    private static iRxProviderService: IRxProviderService;
    private static iTransporterService: ITransporterService;
    private static iInterpreterService: IInterpreterService;
    private static iDriverService: IDriverService;
    private static iFileService: IFileService;
}
